/* eslint-disable import/prefer-default-export */
export const SHOW_OVERLAYS_KEY = 'rsrc.detail.OverlayImageDetail.showOverlays';